// @flow
import React from 'react';
import { useQuery } from '@apollo/client';
import { SelectHookForm } from 'bench-internal-theme';
import { GET_FDS_CONNECTIONS } from '../queries';
import type { FdsConnection, FdsAccountWithConnection, LedgerAccount } from '../types';
import { integrationOptions } from './formOptions';
import { useClient } from '../../ClientContext';

type IntegrationSelectProps = {
  isSubmitting: boolean,
  ledgerAccount: ?LedgerAccount,
};

const IntegrationSelect = ({ isSubmitting, ledgerAccount }: IntegrationSelectProps) => {
  const getFdsAccounts = (
    financialConnections: Array<FdsConnection>,
  ): Array<FdsAccountWithConnection> =>
    financialConnections.reduce(
      (accounts, connection) =>
        accounts.concat(
          connection.accounts.map(account => ({
            ...account,
            connection,
          })),
        ),
      [],
    );

  const client = useClient();
  const { loading, error, data } = useQuery(GET_FDS_CONNECTIONS, {
    variables: { clientId: client?.id },
  });

  const fdsAccounts = getFdsAccounts(data?.client?.financialConnections || []).filter(
    fdsAccount => !fdsAccount.ledger?.id || fdsAccount.ledger?.id === ledgerAccount?.id,
  );

  const fdsAccountForLedgerId = fdsAccounts.find(
    fdsAccount => ledgerAccount && fdsAccount?.ledger?.id === ledgerAccount?.id,
  );

  const options = integrationOptions(fdsAccounts);

  return (
    <SelectHookForm
      isDisabled={isSubmitting || !!error}
      options={options}
      isLoading={loading}
      placeholder={error && 'A problem occurred fetching integrations'}
      aria-label="Integration"
      name="fdsAccountId"
      defaultValue={fdsAccountForLedgerId?.id}
      isSearchable
      isClearable
    />
  );
};

IntegrationSelect.defaultProps = {
  ledgerAccount: undefined,
};

export default IntegrationSelect;
